import { render, staticRenderFns } from "./Korean.vue?vue&type=template&id=fbe63424&scoped=true"
import script from "./Korean.vue?vue&type=script&lang=js"
export * from "./Korean.vue?vue&type=script&lang=js"
import style0 from "./Korean.vue?vue&type=style&index=0&id=fbe63424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe63424",
  null
  
)

export default component.exports